import axios from 'axios';
import { getRequestCommonQuery, checkSupportWebp } from '@lib/utils.js';
// import { sig4 } from '@/lib/sig4.js';

// const sigClass = new sig4();

// 获取公参

axios.interceptors.request.use(
    async config => {
        const ks_params_obj = getRequestCommonQuery();

        // 只有端内才开启webp模式
        const isWebp = checkSupportWebp() && location.pathname.indexOf('app') > 0;

        config.headers['Accept'] = 'application/json';
        // 跨域设置H
        config.withCredentials = true;

        // 开发环境开启debug模式
        if (location.host && location.host.indexOf('h5.getkwai.com') !== 0 && location.host.indexOf('www.zhongnice.com') !== 0 && config.params) {
            config.params.debug = true;
            // config.params.userId = 106040;
            // config.params.ve = '1.8.3';
        }

        // 判断浏览器是否支持webp格式
        // isWebp ? (config.params = { ...config.params, ...{ imgFormat: 'webp' } }) : '';

        // 接口统一添加 公参
        config.params = { ...ks_params_obj, ...config.params };

        // if(sigClass.needSig4(config?.url)){
        //      // 替换url
        //     config.url = await sigClass.requestSig4(config.params, config.headers['accept'], config.method, config.url);
        // }
       

        if (location.protocol.indexOf("kttp") > -1) {
            config.baseURL = location.origin.replace(/^kttp/, "http");
        }

        return config;
    },
    err => {
        console.error(err);
        return Promise.reject(err);
    }
);

axios.interceptors.response.use(
    res => {
        const { data } = res;
        if (data.status === 0 || data.result === 1) {
            data.result = 1;
        }
        return res;
        // console.error(res);
        // throw res;
    },
    err => {
        console.error(err);
        return Promise.reject(err);
    }
);

// axios.defaults.baseURL = '/rest/amazing/operation';
axios.defaults.withCredentials = 'include'; // 加了这段就可以跨域带cookie

export default axios;
